document.addEventListener('DOMContentLoaded', function() {
  function updateCartImages() {
    var cartMetaElements = document.querySelectorAll('.ajaxcart__product-meta');

    cartMetaElements.forEach(function(meta) {
      if (meta.textContent.includes('Custom Image:: ')) {
        // Extract the URL assuming it starts with 'http://' or 'https://'
        var imageUrlMatch = meta.textContent.match(/(http[s]?:\/\/[^\s]+)/);
        if (imageUrlMatch) {
          var imageUrl = imageUrlMatch[0];

          // Change the `meta` element's innerHTML
          meta.innerHTML = 'Personalisiert: <br><a href="' + imageUrl + '" target="_blank">Vorschaubild anzeigen</a>';

          // Change the sibling `.ajaxcart__product-image img` src attribute
          var productImage = meta.closest('.ajaxcart__product').querySelector('.ajaxcart__product-image img');
          if (productImage) {
            productImage.src = imageUrl;
          }
        }
      }
    });
  }

  // Run the update for the initial load
  updateCartImages();

  // Set up a MutationObserver to watch for changes to the "CartDrawer" element
  var elementToObserve = document.getElementById('CartDrawer'); // Replace 'CartDrawer' with the actual id if different
  if (elementToObserve) {
    var observer = new MutationObserver(function(mutationsList, observer) {
      for (var mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          // Rerun the update when there are changes
          updateCartImages();
        }
      }
    });

    // Start observing the target element for configured mutations
    observer.observe(elementToObserve, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }
});